export default __webpack_public_path__ + "static/zachary-hughes-f73a01003b40feb954fb1eec1bd8c031.png";